import React from 'react';
import { Modal, Button } from "react-bootstrap";
import l10n, { LanguageCode, EulaElement } from 'localization/LocalizationData';

interface TermsModalProps {
	Accepted: () => void;
	show: boolean;
	onHide: () => void;
}

export const TermsModal = (props: TermsModalProps) => {
	const firstElemRef = React.useRef<any>();
	return (
		<Modal show={props.show}
			onHide={props.onHide}
			aria-labelledby='termsTitle'
			onEntered={() => { (firstElemRef.current as HTMLDivElement)?.focus() }}
			className='terms-modal'
			scrollable={true}
			size='lg'
			centered={true}>
			<Modal.Header closeButton={true}>
				<Modal.Title id='termsTitle'>{l10n.terms_title}</Modal.Title>
			</Modal.Header>
			<Modal.Body tabIndex={0} ref={firstElemRef}>{EulaElement[l10n.getLanguage() as LanguageCode]}</Modal.Body>
			<Modal.Footer className='justify-content-center mt-4 mb-2'>
				<Button onClick={() => props.Accepted()} variant="primary">
					{l10n.terms_button_accept}
				</Button>
			</Modal.Footer>
		</Modal >
	);
}

export default TermsModal;